module.exports = __webpack_public_path__ + "img/logBG.69417708.png";